import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SessionService } from '../services/session.service';

export const publicOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const session = inject(SessionService);

  session.restoreSession();

  if (!session.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([session.getHomeRouteForCurrentUser()]);
};
